<button
  *ngIf="url && intersected"
  (click)="onOpenModal($event)"
  [style.backgroundImage]="url | backgroundImage"
  class="image"
  type="button"
></button>
